import { render, staticRenderFns } from "./r-store-bundle-table.vue?vue&type=template&id=3303feb6"
import script from "./r-store-bundle-table.vue?vue&type=script&lang=js"
export * from "./r-store-bundle-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3303feb6')) {
      api.createRecord('3303feb6', component.options)
    } else {
      api.reload('3303feb6', component.options)
    }
    module.hot.accept("./r-store-bundle-table.vue?vue&type=template&id=3303feb6", function () {
      api.rerender('3303feb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/product/r-store-bundle-table.vue"
export default component.exports